import React from "react";
import { Github, Linkedin, Mail, Phone, MapPin, Instagram } from "lucide-react";

const Footer = ({ isDarkMode }) => {
  return (
    <footer
      className={`py-12 transition-all duration-500 ${
        isDarkMode
          ? "bg-gray-900 border-t border-gray-800"
          : "bg-white border-t border-gray-100"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent mb-4">
              Ammad Ahmed
            </div>
            <p
              className={`mb-6 max-w-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              }`}
            >
              Passionate Full Stack Developer crafting digital experiences with
              code and creativity.
            </p>
            <div className="flex gap-4">
              {[
                {
                  icon: <Github className="w-5 h-5" />,
                  href: "https://github.com/ahmedammad1709",
                  color: "hover:text-gray-900",
                },
                {
                  icon: <Linkedin className="w-5 h-5" />,
                  href: "https://www.linkedin.com/in/ammad-ahmed-608156338/",
                  color: "hover:text-blue-600",
                },
                {
                  icon: <Instagram className="w-5 h-5" />,
                  href: "https://www.instagram.com/ammad_innovates/",
                  color: "hover:text-pink-600",
                },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`p-3 rounded-full transition-all duration-300 transform hover:scale-110 ${
                    isDarkMode
                      ? "bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white"
                      : "bg-gray-100 text-gray-600 hover:bg-white hover:shadow-lg"
                  } ${social.color}`}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4
              className={`text-lg font-bold mb-4 ${
                isDarkMode ? "text-white" : "text-gray-900"
              }`}
            >
              Quick Links
            </h4>
            <ul className="space-y-2">
              {[
                "Home",
                "About",
                "Education",
                "Services",
                "Projects",
                "Experience",
                "Contact",
              ].map((item) => (
                <li key={item}>
                  <a
                    href={item === "Home" ? "/" : `/#${item.toLowerCase()}`}
                    className={`transition-colors duration-300 ${
                      isDarkMode
                        ? "text-gray-400 hover:text-blue-400"
                        : "text-gray-600 hover:text-blue-600"
                    }`}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4
              className={`text-lg font-bold mb-4 ${
                isDarkMode ? "text-white" : "text-gray-900"
              }`}
            >
              Contact Info
            </h4>
            <ul className="space-y-4">
              {[
                {
                  icon: <Mail className="w-4 h-4" />,
                  text: "ahmedammad2006@gmail.com",
                },
                { icon: <Phone className="w-4 h-4" />, text: "+92 3240236991" },
                { icon: <MapPin className="w-4 h-4" />, text: "Karachi" },
              ].map((item, index) => (
                <li
                  key={index}
                  className={`flex items-center gap-2 ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  {item.icon}
                  <span>{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          className={`pt-8 border-t text-center ${
            isDarkMode
              ? "border-gray-800 text-gray-500"
              : "border-gray-200 text-gray-500"
          }`}
        >
          <p>
            &copy; {new Date().getFullYear()} Ammad Ahmed. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
